import React, { useEffect } from 'react';
import images from '../images';
import styles from '../css/Titulo.module.scss'

export const Titulo = ({ texto, classSubrayado, subrayar}) => {

    return (
        <h2 className={'fw-bold d-inline-block pt-5 pb-4 ' + styles.titulo}>
            <div className='d-inline-block position-relative z-1'>
                {texto}
                {subrayar? <img className={styles.subrayado + " " + classSubrayado} src={images.otros.subrayado} />:<></>}
            </div>
        </h2>
    )

}
